import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Cards from '../Components/Cards'
function Update() {
     
    const [data,setData]=useState([])
   

  useEffect(()=>{
    axios.get('https://tinkus.onrender.com/getData')
    .then((result)=>{
     console.log(result.data.data)
     setData(result.data.data)
     //alert("Create SuccessFully")
    })
   .catch((err)=>{
     console.log(err)

     alert(err.response.data.msg)
   })
  },[])

       

    
   
  return (
    <div>
   {/* <div id='but'> <button id='butt' onClick={Api}>Get Memo List </button></div> */}
    <hr></hr>
         {
           data.map((a)=>{

              return (
                <Cards data={a} />
              )
            
           })
         }
    </div>
  )
}

export default Update
